import {useStore} from "@/store/index.js";
import type {PGStore} from "@/store/index-types";
import type {Store} from "vuex";

export function getStore<T extends Store<any> = PGStore<any>>(): T {
  return useStore() as unknown as T;
}
